function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Videos",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large",
  transform: "translate(-641.000000, -2766.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Footer",
  transform: "translate(0.000000, 2559.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-icons",
  transform: "translate(625.000000, 195.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Social-/-Facebook",
  transform: "translate(16.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,2.66663119 L6.38,2.66663119 C5.268,2.64642082 5.1732,3.63167623 5.1664,3.85525342 L5.1672,3.85525342 L5.1672,5.85481664 L7.8796,5.85481664 L7.548,8.68595227 L5.1672,8.68595227 L5.1672,16 L2.3996,16 L2.3996,8.68595227 L0,8.68595227 L0,5.85481664 L2.3996,5.85481664 L2.3996,3.85525342 L2.4,3.85525342 C2.41,1.93905797 3.0728,1.28516837 3.0728,1.28516837 C4.046,-0.0394527883 5.5724,0 5.5724,0 L5.9884,0 L8,0 L8,2.66663119 Z",
  id: "facebook"
}))))));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "16px",
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Social / Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0091cbf3.svg";
export { ForwardRef as ReactComponent };